import { createEvent } from "@cobuildlab/react-simple-state";

export const OnLogIn = createEvent();
export const OnLogInError = createEvent();
export const OnLogOut = createEvent();
